export const readAsUrlAsync = async (file: File) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)

  return new Promise<string>((resolve, reject) => {
    reader.addEventListener('load', () => {
      resolve(reader.result as string)
    })

    reader.addEventListener('error', () => {
      reject()
    })

    reader.addEventListener('abort', () => {
      reject()
    })
  })
}
